<template>
  <div v-if="getPermission.callLogs.view">

    <md-dialog :md-active.sync="isCommentModalShowing">
      <md-dialog-content v-if="currentEditingCommentItem" style="width: 800px;">
        <md-field>
          <md-textarea style="min-height: 200px" v-model="currentEditingComment" md-autogrow></md-textarea>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="" @click="isCommentModalShowing = false">Close</md-button>
        <md-button class="md-primary" @click="updateEditingComment">Update</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="isPickupHistoryModalShowing">
      <md-dialog-content v-if="currentPickupHistoryItem" style="width: 1080px">
        <div class="md-layout md-gutter" style="font-size: 18px">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <b>Store: </b> {{currentPickupHistoryItem.store.id}}
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <b>Hauler:</b>
            <template v-if="currentPickupHistoryItem.store && currentPickupHistoryItem.store.storeSpecialDto">
              <master-data-display
                  group="Hauler"
                  :tag-id="currentPickupHistoryItem.store.storeSpecialDto.haulerId"/>
            </template>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <b>Store Phone: </b>
            <span>{{currentPickupHistoryItem.storeDto.phone}}</span>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <b>EndOutlet: </b>
            <template v-if="currentPickupHistoryItem.store && currentPickupHistoryItem.store.storeSpecialDto">
              <master-data-display
                  group="EndOutlet"
                  :tag-id="currentPickupHistoryItem.store.storeSpecialDto.endOutletId"
              />
            </template>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <b>Address: </b>
            <span v-if="currentPickupHistoryItem.storeDto">{{currentPickupHistoryItem.storeDto.country}}</span>
            <span v-if="currentPickupHistoryItem.storeDto">{{currentPickupHistoryItem.storeDto.state}}</span>
            <span v-if="currentPickupHistoryItem.storeDto">{{currentPickupHistoryItem.storeDto.city}}</span>
            <span v-if="currentPickupHistoryItem.storeDto">{{currentPickupHistoryItem.storeDto.street}}</span>
          </div>
        </div>

        <hr>

        <calling-api path="/api/w/billOfLoads">
          <div style="max-width: 1080px;min-height: 300px;overflow-y: scroll;">
            <table>
              <thead>
              <tr>
                <th style="text-align: left" class="w4">ETA-Plan</th>
                <th style="text-align: left" class="w4">ETA-Assign</th>
                <th style="text-align: left" class="w4">Pick-up date</th>
                <th style="text-align: left" class="w2-5">Bales picked</th>
                <th style="text-align: left" class="w2-5">Bales left</th>
                <!--<th style="text-align: left" class="w10">Hauler</th>-->
                <th style="text-align: left" class="w4">Dispatcher</th>
                <th style="text-align: left" class="w6">Dispatcher<br/>Phone</th>
                <th style="text-align: left" class="w6">Driver</th>
                <th style="text-align: left" class="w5">Load ID</th>
                <th style="text-align: left" class="w4">BOL ID</th>
              </tr>
              </thead>
              <tbody>
              <tr :key="b.id" v-for="b in pickupBols">
                <td class="w4">{{b.eta | date}}</td>
                <td class="w4">{{b.etaAssigned | date}}</td>
                <td class="w4">{{b.pickUpDate | date}}</td>
                <td class="w2-5">{{b.balePicked}}</td>
                <td class="w2-5">{{b.baleLeft}}</td>
                <!--<td class="w10">-->
                <!--<master-data-display group="Hauler" :tag-id="b.haulerId"/>-->
                <!--</td>-->
                <td class="w4">
                  <template v-if="b.load">{{b.load.createdBy}}</template>
                </td>
                <td class="w6">
                  <template v-if="b.load && b.load.createUser">{{b.load.createUser.mobileNo}}</template>
                </td>
                <td class="w6">{{b.driverId}}</td>
                <td class="w5">{{b.loadIdUsed}}</td>
                <td class="w4">{{b.id}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </calling-api>
      </md-dialog-content>
      <md-dialog-actions style="max-width: 960px">
        <md-button class="md-primary" @click="isPickupHistoryModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-card class="searchPanel">
      <md-card-content v-if="searchRequest">
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.callDateFrom" @keyup.enter="doSearch">
                  <label>Call Date</label>
                </datepicker>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.callDateTo" @keyup.enter="doSearch">
                  <label>To</label>
                </datepicker>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>Store</label>
                  <md-input v-model="searchRequest.storeFrom" @keyup.enter="doSearch"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>To</label>
                  <md-input v-model="searchRequest.storeTo" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>City</label>
                  <md-input v-model="searchRequest.cityFrom" @keyup.enter="doSearch"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>To</label>
                  <md-input v-model="searchRequest.cityTo" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.pickupEtaFrom" @keyup.enter="doSearch">
                  <label>Pickup ETA</label>
                </datepicker>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.pickupEtaTo" @keyup.enter="doSearch">
                  <label>To</label>
                </datepicker>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                    label="State"
                    group="State"
                    v-model="searchRequest.states">
                </auto-complete-master-data-multiple-select>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>Created By</label>
                  <md-input v-model="searchRequest.createdBy" @keyup.enter="doSearch"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-checkbox v-model="showClosed">
                  <label>Show Closed</label>
                </md-checkbox>
              </div>
            </div>
          </div>

        </div>
      </md-card-content>
      <md-card-actions md-alignment="space-between">
        <div>
          <calling-api :paths="['/api/w/callLogs/action','/api/w/excel/generate']">
            <md-button v-if="getPermission.callLogs.edit" class="md-primary md-raised" @click="doCreate">New</md-button>
            <md-button v-if="getPermission.callLogs.edit" :disabled="!canClose" class="md-primary md-raised" @click="doClose">Close</md-button>
            <md-button v-if="getPermission.callLogs.edit" :disabled="!canSave" class="md-primary md-raised" @click="doUpdate">Save</md-button>
            <md-button v-if="getPermission.callLogs.edit" :disabled="!canDelete" class="md-accent md-raised" @click="doDelete">Delete</md-button>
            <md-button v-if="getPermission.callLogs.edit" :disabled="!canViewStoreDetail" class="md-raised" @click="doViewStoreDetail">Store Detail</md-button>
            <md-button :disabled="!canDownloadWalmart" class="md-raised" @click="doDownloadWalmart">Walmart</md-button>
          </calling-api>
        </div>
        <div></div>
        <div>
          <calling-api path="/api/w/callLogs">
            <md-button class="md-primary md-raised" @click="doSearch">Search</md-button>
            <md-button class="md-raised" @click="clearSearch">Clear</md-button>
          </calling-api>
        </div>
      </md-card-actions>
    </md-card>
    <br/>

    <pagination :items="getCallLogsToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2" v-if="getPermission.callLogs.edit">
                      <md-checkbox v-model="allItemsSelected" @change="handleAllItemSelectedChanged">
                      </md-checkbox>
                    </th>
                    <th class="header-cell w5">
                      <sort :sort.sync="sort" field="rawCallDate">
                        Call Date
                      </sort>
                    </th>
                    <th class="header-cell w4">Call Time</th>
                    <th class="header-cell w5">Store</th>
                    <th class="header-cell w5">City</th>
                    <th class="header-cell w4">State</th>
                    <th class="header-cell w4">Location Type</th>
                    <th class="header-cell w4">Recyclables Type</th>
                    <th class="header-cell w5">
                      <sort :sort.sync="sort" field="rawPickupEta">
                        Pickup ETA
                      </sort>
                    </th>
                    <th class="header-cell w5">
                      <sort :sort.sync="sort" field="rawConfirmedPickupDate">
                        Confirmed Pickup Date
                      </sort>
                    </th>
                    <th class="header-cell w5">
                      <sort :sort.sync="sort" field="rawLastServiceDate">
                        Last Service Date
                      </sort>
                    </th>
                    <th class="header-cell w3">MP</th>
                    <th class="header-cell w3">Clean-Out</th>
                    <th class="header-cell w15">Comments</th>
                    <th class="header-cell w8">Extra Cost</th>
                    <th class="header-cell w5">Pickup Type</th>
                    <th class="header-cell w15">End Outlet</th>
                    <th class="header-cell w15">HAULER</th>
                    <th class="header-cell w5">Format</th>
                    <th class="header-cell w2-5">Closed</th>
                    <th class="header-cell w5">Close Person</th>
                    <th class="header-cell w5">
                      <sort :sort.sync="sort" field="closedAt">
                        Close Date
                      </sort>
                    </th>
                    <th class="header-cell w3">Close Time</th>
                    <th class="header-cell w5">Create Person</th>
                    <th class="header-cell w5">Create Date</th>
                    <th class="header-cell w3">Create Time</th>
                    <th class="header-cell w5">Change Person</th>
                    <th class="header-cell w5">Change Date</th>
                    <th class="header-cell w3">Change Time</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr :key="item.id" v-for="item in pageItems">
                    <td class="body-cell w2" v-if="getPermission.callLogs.edit">
                      <md-checkbox v-model="item.selected">
                      </md-checkbox>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.closed">
                        {{item.callDate}}
                      </template>
                      <template v-else>
                        <md-field>
                          <md-input v-model="item.callDate"/>
                        </md-field>
                        <span class="md-error" v-if="isDateInvalid(item.callDate)">Invalid format</span>
                      </template>
                    </td>
                    <td class="body-cell w4" style="vertical-align: center">
                      <template v-if="item.closed">
                        {{item.callTime}}<span style="padding-top: 6px">&nbsp;&nbsp;&nbsp;&nbsp;{{item.rawCallDate | tz}}</span>
                      </template>
                      <template v-else>
                        <md-field style="max-width: 45px">
                          <md-input style="max-width: 45px" v-model="item.callTime"/>
                          <span style="padding-top: 6px">&nbsp;{{item.rawCallDate | tz}}</span>
                        </md-field>
                        <span class="md-error" v-if="isTimeNotValid(item.callTime)">Invalid format</span>
                      </template>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.closed">
                        {{item.storeId}}
                      </template>
                      <template v-else>
                        <md-field>
                          <md-input v-model="item.storeId" @keyup.enter="getStore(item)"/>
                        </md-field>
                      </template>
                    </td>
                    <td class="body-cell w5">{{item.store.city}}</td>
                    <td class="body-cell w4">{{item.store.region}}</td>
                    <td class="body-cell w4">{{item.store.locationType}}</td>
                    <td class="body-cell w4">{{item.recyclablesType}}</td>
                    <td class="body-cell w5">
                      <template v-if="item.closed">
                        {{item.pickupEta}}
                      </template>
                      <template v-else>
                        <md-field>
                          <md-input v-model="item.pickupEta"/>
                        </md-field>
                        <span class="md-error" v-if="isDateInvalid(item.pickupEta)">Invalid format</span>
                      </template>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.closed">
                        {{item.confirmedPickupDate}}
                      </template>
                      <template v-else>
                        <md-field>
                          <md-input v-model="item.confirmedPickupDate"/>
                        </md-field>
                        <span class="md-error" v-if="isDateInvalid(item.confirmedPickupDate)">Invalid format</span>
                      </template>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.closed">
                        {{item.lastServiceDate}}
                      </template>
                      <template v-else>
                        <md-field>
                          <md-input v-model="item.lastServiceDate"/>
                        </md-field>
                        <span class="md-error" v-if="isDateInvalid(item.lastServiceDate)">Invalid format</span>
                      </template>
                    </td>
                    <td class="body-cell w3">{{item.mp}}</td>
                    <td class="body-cell w3">
                      <template v-if="item.closed">
                        {{item.cleanOut}}
                      </template>
                      <template v-else>
                        <md-field>
                          <md-select v-model="item.cleanOut">
                            <md-option value="Yes">Yes</md-option>
                            <md-option value="No">No</md-option>
                          </md-select>
                        </md-field>
                      </template>
                    </td>
                    <td class="body-cell w15">
                      <div class="truncate">
                        <md-button @click="toggleEditComments(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                        {{item.comments}}
                      </div>
                    </td>
                    <td class="body-cell w8">
                      <template v-if="item.closed">
                        {{item.extraCost}}
                      </template>
                      <template v-else>
                        <md-field>
                          <md-select v-model="item.extraCost">
                            <md-option value="B">Baler Down</md-option>
                            <md-option value="O">Other Issues</md-option>
                          </md-select>
                        </md-field>
                      </template>
                    </td>
                    <td class="body-cell w5">{{item.store.pickUpTypeName}}</td>
                    <td class="body-cell w15">
                      <template v-if="item.storeSpecialStatusId && !item.closed">
                        <master-data-select
                            group="EndOutlet"
                            v-model="item.endOutletId"
                        />
                      </template>
                      <template v-else>
                        <master-data-display group="EndOutlet" :tag-id="item.endOutletId"></master-data-display>
                      </template>
                    </td>
                    <td class="body-cell w15">
                      <template v-if="item.storeSpecialStatusId  && !item.closed">
                        <master-data-select
                            group="Hauler"
                            v-model="item.haulerId"
                        />
                      </template>
                      <template v-else>
                        <master-data-display group="Hauler" :tag-id="item.haulerId"></master-data-display>
                      </template>
                    </td>
                    <td class="body-cell w5">{{item.store.industryName}}</td>
                    <td class="body-cell w2-5">
                      <md-checkbox :disabled="item.closed" v-model="item.editingClosed"/>
                    </td>
                    <td class="body-cell w5">{{item.closedBy}}</td>
                    <td class="body-cell w5">
                      {{item.closedAt | date}}
                    </td>
                    <td class="body-cell w3">{{item.closedAt | time}}</td>
                    <td class="body-cell w5">{{item.createdBy}}</td>
                    <td class="body-cell w5">{{item.createdAt | date}}</td>
                    <td class="body-cell w3">{{item.createdAt | time}}</td>
                    <td class="body-cell w5">{{item.updatedBy}}</td>
                    <td class="body-cell w5">{{item.updatedAt | date}}</td>
                    <td class="body-cell w3">{{item.updatedAt | time}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>
  .truncate {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>

<script>
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest from '../utils/excel';
  import validateDate from '../utils/validate-date';
  import validateTime from '../utils/validate-time';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import { sortList } from '../utils/sort';

  function getInitSearchRequest(vm) {
    return {
      callDateFrom: moment().add(-1, 'day').startOf().format('M/D/YYYY'),
      callDateTo: moment().endOf().format('M/D/YYYY'),
      storeFrom: null,
      storeTo: null,
      pickupEtaFrom: null,
      pickupEtaTo: null,
      states: [],
      cityFrom: null,
      cityTo: null,
      createdBy: null,
    };
  }

  export default {
    data: () => ({
      searchRequest: null,
      callLogs: [],
      pickupBols: [],
      currentPickupHistoryItem: null,
      isPickupHistoryModalShowing: false,
      allItemsSelected: false,
      isCommentModalShowing: false,
      currentEditingCommentItem: null,
      currentEditingComment: null,
      sort: {
        field: `rawCallDate`,
        ascending: false,
      },
      showClosed: true,
    }),
    computed: {
      ...mapGetters([
        'getCallLogs',
        'getMasterDataName',
        'getUserProfile',
        'getPermission',
      ]),
      getCallLogsToDisplay() {
        const list = sortList(this.callLogs, this.sort);
        if (this.showClosed) {
          return list;
        } else {
          return _(list).filter(it => it.closed !== true);
        }
      },
      getSelectedCallLogs() {
        return _(this.callLogs).filter(it => it.selected);
      },
      canDelete() {
        return this.getSelectedCallLogs.length > 0;
      },
      canSave() {
        return this.getSelectedCallLogs.length > 0;
      },
      canClose() {
        if (this.getSelectedCallLogs.length === 0) {
          return false;
        }
        if (_(this.getSelectedCallLogs).find(it => it.closed === true)) {
          return false;
        }
        return true;
      },
      canViewStoreDetail() {
        const items = this.getSelectedCallLogs;
        if (items.length !== 1) {
          return false;
        }
        const item = items[0];
        return !!item.store;
      },
      canDownloadWalmart() {
        return this.callLogs.length > 0;
      },
    },
    watch: {
      getCallLogs(val) {
        this.updateCachedCallLogsFromApi(val);
      },
    },
    mounted() {
      this.updateCachedCallLogsFromApi(this.getCallLogs);
      const cachedSearchRequest = this.$store.state.callLogs.searchRequest;
      if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      } else {
        this.searchRequest = getInitSearchRequest(this);
      }
    },
    methods: {
      isDateInvalid(dateString) {
        if (dateString) {
          return !validateDate(dateString);
        }
        return false;
      },
      isTimeNotValid(value) {
        if (value) {
          const valid = validateTime(value);
          return !valid;
        }
        return false;
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header')).offset({ left: -1 * (e.target.scrollLeft - $('.outer-container').offset().left) });
      },
      updateCallLogs(callLogs) {
        this.callLogs = callLogs;
      },
      doSearch() {
        this.callLogs = [];
        this.$nextTick(() => {
          this.$store.dispatch('loadCallLogs', this.searchRequest);
        });
      },
      clearSearch() {
        // _(this.$el.querySelectorAll('.searchPanel button.md-input-action.md-clear')).each((it) => {
        //   it.click();
        // });
        this.$nextTick(() => {
          this.searchRequest = getInitSearchRequest(this);
        });
      },
      doCreate() {
        this.callLogs = [
          {
            isNew: true,
            id: `${Math.random() * 99999999}`,
            callDate: dateFormat.date(new Date()),
            callTime: dateFormat.timeHHmm(new Date()),
            cleanOut: null,
            comments: null,
            confirmedPickupDate: null,
            confirmedPickupTime: null,
            createdAt: null,
            createTime: null,
            createdBy: null,
            extraCost: null,
            lastServiceDate: null,
            lastServiceTime: null,
            mp: null,
            pickupEta: null,
            pickupEtaTime: null,
            recyclablesType: null,
            editingClosed: false,
            store: {
              id: null,
              name: null,
              city: null,
              region: null,
              locationType: null,
              pickUpTypeName: null,
              endOutlet: null,
              industryName: null,
            },
            selected: true,
          }
        ];
      },
      doClose() {
        _(this.getSelectedCallLogs).each(it => {
          it.editingClosed = true;
        });
      },
      doUpdate() {
        const combineDateAndTime = (date, time) => {
          if (!date) {
            return null;
          }
          const dateString = moment(date).format('YYYYMMDD');
          const timeString = time || '00:00';
          return moment(dateString + timeString, 'YYYYMMDDHHmm').toDate();
        };
        const promises = _(this.getSelectedCallLogs)
          .chain()
          .map((it) => {
            if (this.isDateInvalid(it.callDate) || this.isDateInvalid(it.pickupEta) || this.isDateInvalid(it.confirmedPickupDate)
              || this.isDateInvalid(it.lastServiceDate) || this.isTimeNotValid(it.callTime)) {
              return null;
            }
            const req = {
              action: it.isNew ? 'NEW' : 'UPDATE',
              id: it.id,
              callDate: combineDateAndTime(it.callDate, it.callTime),
              storeId: it.storeId,
              pickupEta: combineDateAndTime(it.pickupEta, it.pickupEtaTime),
              confirmedPickupDate: combineDateAndTime(it.confirmedPickupDate, it.confirmedPickupTime),
              lastServiceDate: combineDateAndTime(it.lastServiceDate, it.lastServiceTime),
              cleanOut: it.cleanOut,
              comments: it.comments,
              extraCost: it.extraCost,
              haulerId: it.haulerId,
              endOutletId: it.endOutletId,
              closed: it.editingClosed,
            };
            return this.$store.dispatch('saveCallLogs', req);
          })
          .filter(it => !!it)
          .value();
        Promise.all(promises).then(() => {
          this.doSearch();
        });
      },
      doDelete() {
        if (!window.confirm('Delete Selected Items?')) {
          return;
        }
        const promises = _(this.getSelectedCallLogs)
          .chain()
          .filter(it => !it.isNew)
          .map((it) => {
            const req = {
              action: 'DELETE',
              id: it.id,
            };
            return this.$store.dispatch('saveCallLogs', req);
          })
          .value();
        Promise.all(promises).then(() => {
          this.doSearch();
        });
      },
      doViewStoreDetail() {
        this.isPickupHistoryModalShowing = true;
        const item = this.getSelectedCallLogs[0];
        this.currentPickupHistoryItem = item;
        const request = {
          storeIds: [item.store.id],
          pickUpStart: moment().startOf('month').add(-1, 'month').toDate(),
          pickUpEnd: moment().endOf('month').toDate(),
          withLoadCreateUser: true,
        };
        //api.post('/api/w/billOfLoads', request).then((bols) => {
        newAPIPost('/api/w/billOfLoads', request).then((bols) => {
          this.pickupBols = bols;
        });
      },
      doDownloadWalmart() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Walmart.xls',
          1,
        );
        request.heads = _(request.heads).take(13);

        request.rows = _(this.getCallLogsToDisplay)
          .chain()
          .map((it) => {
            return [
              it.callDate,
              `${it.callTime} ${dateFormat.tz(it.rawCallDate)}`,
              it.storeId,
              _(it).lookup('store.city'),
              _(it).lookup('store.region'),
              _(it).lookup('store.locationType'),
              it.recyclablesType,
              it.pickupEta,
              it.confirmedPickupDate,
              it.lastServiceDate,
              it.mp,
              it.cleanOut,
              it.comments,
            ]
          });

        console.log(JSON.stringify(request));
        this.$store.dispatch('generateExcel', request).then((res) => {
          window.open(res.url, 'blank');
        });
      },
      handleAllItemSelectedChanged() {
        _(this.callLogs).each(it => {
          it.selected = this.allItemsSelected;
        })
      },
      getStore(item) {
        const storeId = item.storeId;
        if (storeId) {
          if (storeId.length <= 3) {
            return;
          }

          //api.post(`/api/w/stores/getOne`, { storeId }).then((store) => {
          newAPIPost(`/api/w/stores/getOne`, { storeId }).then((store) => {
            console.log(store);
            item.store = store || {};
            if (store) {
              item.endOutletId = _.lookup(store, 'storeSpecial.endOutletId') || item.endOutletId;
              item.haulerId = _.lookup(store, 'storeSpecial.haulerId') || item.haulerId;
            } else {
              item.endOutletId = null;
              item.haulerId = null;
            }
          });
        }
      },
      toggleEditComments(item) {
        this.currentEditingCommentItem = item;
        this.currentEditingComment = `${item.comments || ''}`;
        this.isCommentModalShowing = true;
      },
      updateEditingComment() {
        this.currentEditingCommentItem.comments = this.currentEditingComment;
        this.isCommentModalShowing = false;
      },
      updateCachedCallLogsFromApi(newCallLogs) {
        this.allItemsSelected = false;
        const callLogs = _(JSON.parse(JSON.stringify(newCallLogs))).sortBy(it => it.callDate).reverse();
        this.updateCallLogs(_(callLogs).map(callLog => ({
          dto: callLog,
          id: callLog.id,
          storeId: callLog.storeId,
          rawCallDate: callLog.callDate,
          callDate: dateFormat.date(callLog.callDate),
          callTime: dateFormat.timeHHmm(callLog.callDate),
          cleanOut: callLog.cleanOut,
          comments: callLog.comments,
          rawConfirmedPickupDate: callLog.confirmedPickupDate,
          confirmedPickupDate: dateFormat.date(callLog.confirmedPickupDate),
          confirmedPickupTime: dateFormat.timeHHmm(callLog.confirmedPickupDate),
          createdAt: callLog.createdAt,
          createdBy: callLog.createdBy,
          updatedBy: callLog.updatedBy,
          updatedAt: callLog.updatedAt,
          extraCost: callLog.extraCost,
          closed: callLog.closed === true,
          editingClosed: callLog.closed === true,
          closedBy: callLog.closedBy,
          closedAt: callLog.closedAt,
          rawLastServiceDate: callLog.lastServiceDate,
          lastServiceDate: dateFormat.date(callLog.lastServiceDate),
          lastServiceTime: dateFormat.timeHHmm(callLog.lastServiceDate),
          mp: callLog.mp,
          rawPickupEta: callLog.pickupEta,
          pickupEta: dateFormat.date(callLog.pickupEta),
          pickupEtaTime: dateFormat.timeHHmm(callLog.pickupEta),
          recyclablesType: callLog.recyclablesType,
          storeDto: callLog.store,
          endOutletId: callLog.endOutletId || _.lookup(callLog, 'store.storeSpecial.endOutletId'),
          haulerId: callLog.haulerId || _.lookup(callLog, 'store.storeSpecial.haulerId'),
          storeSpecialStatusId: _.lookup(callLog, 'store.storeSpecial.statusId'),
          store: {
            id: _.lookup(callLog, 'store.id'),
            name: _.lookup(callLog, 'store.name'),
            city: _.lookup(callLog, 'store.city'),
            region: _.lookup(callLog, 'store.region'),
            locationType: _.lookup(callLog, 'store.locationType'),
            pickUpTypeName: _.lookup(callLog, 'store.pickUpTypeName'),
            industryName: _.lookup(callLog, 'store.industryName'),
            storeSpecialDto: _.lookup(callLog, 'store.storeSpecial'),
          },
          selected: false,
        })));
      },
    },
  };
</script>
